var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { responsiveLabelFont, responsiveTextAlignStyle } from '../../styles/internal';
import { labelBaseStyle } from './styles';
const Root = styled.div(responsiveLabelFont, responsiveTextAlignStyle, labelBaseStyle);
export const Label = forwardRef((props, ref) => {
    const { accent, align, children, muted = false, size = 2, weight } = props, restProps = __rest(props, ["accent", "align", "children", "muted", "size", "weight"]);
    return (React.createElement(Root, Object.assign({ "data-ui": "Label" }, restProps, { "$accent": accent, "$align": align, "$muted": muted, "$size": size, "$weight": weight, ref: ref }), children));
});
Label.displayName = 'Label';
//# sourceMappingURL=label.js.map